// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","smallWidth":"768px","mobileThreshold":"575px","button":"UpgradeAlert_button__1Jjk6","text":"UpgradeAlert_text__1kJha"};